import { isObject, objectToGet } from '../functions/index'

/**
 * Collection // Collectionの定義
 *
 * @returns {undefined}
 */

class Collection {
  constructor(data = []) {
    if (isObject(data)) data = Object.values(data)
    if (!Array.isArray(data)) throw new Error('配列で初期化してください')
    this.data = data
    return this
  }

  /**
   * correct // 内部変数にデータをセットする
   *
   * @param {array} data
   * @return this
   */
  correct(data = []) {
    if (Array.isArray(data)) this.data = data
    else throw new Error('配列を入れてください')
    return this
  }

  /**
   * map // マップで繰り返す
   *
   * @param {function} func
   * @return this
   */
  map(func) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    this.data = this.data.map((currentValue, index, array) => func(currentValue, index, array))
    return this
  }

  /**
   * find // 探す
   *
   * @param {function} func
   * @return item
   */
  find(func) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    return this.data.find(item => func(item))
  }

  /**
   * filter // フィルターする
   *
   * @param {function} func
   * @return this
   */
  filter(func) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    if (this.data.length) {
      this.data = this.data.filter((item, index, array) => func(item, index, array))
    }
    return this
  }

  /**
   * unshift // 配列の先頭に追加する
   *
   * @param {any} data
   * @return this
   */
  unshift(data) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    if (data.length !== 0) this.data.unshift(data)
    return this
  }

  /**
   * concat // 配列を結合する
   *
   * @param {array} data
   * @return this
   */
  concat(data) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    console.log('確認です。', data.length !== 0 && Array.isArray(data))
    if (data.length !== 0 && Array.isArray(data)) this.data = this.data.concat(data)
    return this
  }

  /**
   * push // 配列の最後に追加する
   *
   * @param {any} data
   * @return this
   */
  push(data) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    if (data) this.data.push(data)
    return this
  }

  /**
   * pickup.
   *
   * @param {string} name // プロパティー名
   * @param {boolean} override // コレクトの配列をオーバーライドするか デフォルトfalse
   * @return {this | array}
   */
  pickup(name, override = false) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    const result = []
    this.data.map(item => {
      const data = objectToGet(item, name, null)
      if (data) result.push(data)
    })
    if (override) {
      this.data = result
      return this
    }
    return result
  }

  /**
   * get // 配列データを返す
   *
   * @return {array} data
   */
  get() {
    return this.data
  }

  /**
   * count // 配列の個数を返す
   *
   * @return {number}
   */
  count() {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    return this.data.length
  }

  /**
   * first // 最初のアイテムを返す
   *
   * @return {any}
   */
  first() {
    return objectToGet(this.data, '0', null)
  }

  /**
   * maxIndex // 配列の最大インデックス値を返す
   *
   * @return {number}
   */
  maxIndex() {
    return this.count() - 1
  }

  /**
   * sort // ソートする
   *
   * @param {boolean} desc // デフォルト 降順 昇順のばあいfalse
   * @param {string} item // 比較対象がobjectの場合
   * @return this
   */
  sort(desc = true, item = null) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    const compare = (a, b, desc = true) => {
      /* eslint no-self-compare: 0 */
      if (a !== a && b !== b) return 0
      if (a !== a) return 1
      if (b !== b) return -1

      if (a == null && b == null) return 0
      if (a == null) return 1
      if (b == null) return -1

      if (a === '' && b === '') return 0
      if (a === '') return 1
      if (b === '') return -1

      var sig = desc ? 1 : -1
      return a < b ? sig : a > b ? -sig : 0
    }
    this.data.sort((a, b) => {
      if (item) {
        const itemA = objectToGet(a, item, null)
        const itemB = objectToGet(b, item, null)
        return compare(itemA, itemB, desc)
      }
      return compare(a, b, desc)
    })
    return this
  }

  /**
   * unique // 重複を削除する
   *
   * @return this
   */
  unique() {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    const uniqueArray = []
    for (const elem of this.data) {
      if (uniqueArray.indexOf(elem) < 0) uniqueArray.push(elem)
    }
    this.data = uniqueArray
    return this
  }

  /**
   * objectUnique. // オブジェクトの重複を削除
   *
   * @param {} path // 重複を判定するキー
   *
   * @return this
   */
  objectUnique(path) {
    if (!Array.isArray(this.data)) throw new Error('correctしてください')
    const uniqueArray = []
    const stackData = []
    for (const elem of this.data) {
      const data = objectToGet(elem, path)
      if (data && stackData.indexOf(data) < 0) {
        stackData.push(data)
        uniqueArray.push(elem)
      }
    }
    this.data = uniqueArray
    return this
  }
}

export default Collection
